import { axios } from '@v2/utils/httpRequest.js';

// actions
export default {
  updateUnreadCount({ commit }, count) {
    console.log('updateUnreadCount', count);
    commit('setUnreadCount', count);
  },

  updateUnreadIds({ commit }, count) {
    console.log('updateUnreadIds', count);
    commit('setUnreadIds', count);
  },

  /** 事前問診未読数取得 */
  async fetchQuestionnaireUnreadCount({ commit }, receptionItemId) {
    return await axios
      .get(`${import.meta.env.VITE_API_DOMAIN}/api/v3/clinic/questionnaire/unread_count`, {
        params: {reception_item_id: receptionItemId},
      })
      .then((res) => {
        commit('setUnreadCount', res.data.unread_count);
      })
      .catch((error) => {
        throw error.response;
      });
  },

  /** サーバー側の事前問診未読数キャッシュクリア */
  async fetchQuestionnaireUnreadCountCacheClear() {
    return await axios
      .delete(`${import.meta.env.VITE_DOMAIN}/clinic/cache/clear/unread_questionnaire_count`)
      .catch((error) => {
        throw error.response;
      });
  },

  /** 事前問診一括既読API */
  async updateQuestionnaireRead({ commit }, receptionItemId) {
    console.log('updateQuestionnaireRead', receptionItemId);
    return await axios
      .post('/api/v2/clinic/questionnaires/all_read', {
        reception_item_id: receptionItemId,
      })
      .then(() => {
        console.log('updateQuestionnaireRead');
        commit('setUnreadIds', []);
      })
      .catch((error) => {
        throw error.response;
      });
  },


  /** サーバー側のオンライン受付未読数キャッシュクリア */
  async fetchNotificationUnreadCountCacheClear() {
    return await axios
      .delete(`${import.meta.env.VITE_DOMAIN}/clinic/cache/clear/unread_notification_count`)
      .catch((error) => {
        throw error.response;
      });
  },
};
